import { render, staticRenderFns } from "./systemAbout.vue?vue&type=template&id=e2cce5d4&scoped=true&"
import script from "./systemAbout.vue?vue&type=script&lang=js&"
export * from "./systemAbout.vue?vue&type=script&lang=js&"
import style0 from "./systemAbout.vue?vue&type=style&index=0&id=e2cce5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cce5d4",
  null
  
)

export default component.exports